import React from "react";
import { useDispatch } from "react-redux"; // Added
import { IoMdAdd } from "react-icons/io";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { IoCheckmarkCircleOutline } from "react-icons/io5"; // Added
import { useLocation } from "react-router-dom";
import { toggleDrawer } from "../../Redux/slices/TaskSlice"; // Added
import TaskDrawer from "../../Components/TaskDrawer/TaskDrawer"; // Added

const SingleChatSideBarHeader = ({
  moreNewChat,
  setMoreNewChat,
  setChatSearch,
  setAllUserSearch,
  setAllUserCurrentPage,
}) => {
  const location = useLocation();
  const dispatch = useDispatch(); // Added
  const isGroupRoute = location.pathname.startsWith("/group");
  const isChannelRoute = location.pathname.startsWith("/channels");
  const isSettingsRoute = location.pathname.startsWith("/settings");
  const isHomeRoute = location.pathname.startsWith("/home");

  // Show Task button ONLY on Chat (Home) and Group routes
  const showTaskButton = (isHomeRoute || isGroupRoute) && !moreNewChat && !isSettingsRoute && !isChannelRoute;

  return (
    <header
      className={`w-full items-center min-h-[67px] py-2.5 bg-transparent text-zinc-800 text-center flex px-5 select-none ${moreNewChat ? "justify-start" : "justify-between"
        }`}
    >
      {moreNewChat && (
        <MdOutlineArrowBackIosNew
          className="border border-gray-300 p-1.5 mr-3 rounded text-3xl cursor-pointer"
          onClick={() => {
            if (isHomeRoute) {
              setChatSearch("");
            }
            setAllUserCurrentPage(1);
            setMoreNewChat(false); // Go back from 'New Chat'
          }}
        />
      )}
      <h1 className="text-lg font-semibold dark:text-gray-300">
        {isGroupRoute
          ? "Groups"
          : isChannelRoute
            ? "Channels"
            : isSettingsRoute
              ? "Settings" // Add the condition for settings
              : moreNewChat && isHomeRoute
                ? "New Chats"
                : "All Chats"}
      </h1>

      {!isSettingsRoute && !moreNewChat && (
        <div className="flex items-center gap-2">
          {/* Task Button */}
          {showTaskButton && (
            <div
              className="cursor-pointer bg-white border border-zinc-200 text-zinc-600 p-2 rounded-full shadow-sm hover:bg-zinc-50 hover:text-indigo-600 transition-colors h-[32px] flex items-center justify-center w-[32px]"
              onClick={() => dispatch(toggleDrawer(true))}
              title="Tasks"
            >
              <IoCheckmarkCircleOutline className="text-xl text-inherit" />
            </div>
          )}

          {/* Add Button */}
          <div
            className="cursor-pointer bg-white border border-zinc-200 text-zinc-600 p-2 rounded-full shadow-sm hover:bg-zinc-50 hover:text-indigo-600 transition-colors h-[32px] flex items-center justify-center w-[32px]"
            onClick={() => {
              if (isHomeRoute) {
                setAllUserSearch("");
              }
              setMoreNewChat(true);
            }}
          >
            <IoMdAdd className="text-xl text-inherit" />
          </div>
        </div>
      )}

      {/* Global Task Drawer - Mounted here to be available when header is visible */}
      <TaskDrawer />
    </header>
  );
};

export default SingleChatSideBarHeader;
